import { DateObj } from 'dayzed';
import { isBefore, startOfDay, isEqual } from 'date-fns';
import { DateRange, ValuesRef } from '../types';

export function getNewDates(values: ValuesRef, selectedDateObj: DateObj): DateRange {
  const selectedDate = startOfDay(selectedDateObj.date);
  const { startDate } = values.current.draftDates;

  // reset if no start date, or selected is before or equal to start date
  if (!startDate || (startDate && isBefore(selectedDate, startDate)) || (startDate && isEqual(selectedDate, startDate))) {
    return { startDate: selectedDate, endDate: undefined };
  }

  return { startDate: startDate, endDate: selectedDate };
}
